import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import EmailEditor from "../components/EmailEditor";
import { Loader2 } from "lucide-react";

const TYPE_LABELS = {
  proposal_sent: "Envoi de la proposition (au prospect)",
  follow_up: "Relance 48 h (au prospect)",
  question: "Question reçue (notification interne)",
  decision: "Décision — accepté/refusé (notification interne)",
  invitation: "Invitation d'un membre",
};

const TYPE_ORDER = ["proposal_sent", "follow_up", "question", "decision", "invitation"];

export default function AdminEmails() {
  const [templates, setTemplates] = useState(null);

  const load = () =>
    api.get("/admin/email-templates")
      .then((r) => {
        const sorted = [...(r.data || [])].sort((a, b) => TYPE_ORDER.indexOf(a.type) - TYPE_ORDER.indexOf(b.type));
        setTemplates(sorted);
      })
      .catch((e) => { toast.error(e.response?.data?.detail || e.response?.data?.message || "Erreur de chargement"); setTemplates([]); });

  useEffect(() => { load(); }, []);

  return (
    <div className="max-w-6xl space-y-8" data-testid="admin-emails-page">
      <div>
        <h1 className="font-heading text-3xl lg:text-4xl font-bold tracking-tight">Modèles d'email</h1>
        <p className="text-muted-foreground mt-2">Modèles par défaut envoyés par <strong>toute la plateforme</strong>. Chaque société peut surcharger ces modèles avec ses propres textes dans ses Paramètres.</p>
      </div>

      {templates === null ? (
        <div className="flex items-center gap-2 text-muted-foreground"><Loader2 className="w-4 h-4 animate-spin" /> Chargement…</div>
      ) : templates.length === 0 ? (
        <p className="text-muted-foreground">Aucun modèle disponible.</p>
      ) : (
        <div className="space-y-8">
          {templates.map((tpl) => (
            <div key={tpl.type} className="bg-card border border-border rounded-sm p-6 lg:p-8" data-testid={`admin-email-${tpl.type}`}>
              <EmailEditor
                type={tpl.type}
                label={TYPE_LABELS[tpl.type] || tpl.type}
                pixel={tpl.pixel}
                variables={tpl.variables || []}
                subject={tpl.subject || ""}
                body={tpl.body || ""}
                previewUrl="/admin/email-templates/preview"
                onSave={async ({ subject, body }) => {
                  await api.put(`/admin/email-templates/${tpl.type}`, { subject, body });
                  await load();
                }}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
